import React, { useEffect, useRef } from 'react';

interface IUseClickOutsideProps {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setOptionFilter?: React.Dispatch<React.SetStateAction<string>>;
}

export const useClickOutside = ({ isOpen, setIsOpen, setOptionFilter }: IUseClickOutsideProps) => {
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
                setIsOpen(false);
                setOptionFilter && setOptionFilter('');
            }
        };

        // Capture keeps outside clicks observable when a parent stops event bubbling.
        if (isOpen) {
            window.addEventListener('click', handleClickOutside, true);
        } else {
            window.removeEventListener('click', handleClickOutside, true);
        }

        return () => {
            window.removeEventListener('click', handleClickOutside, true);
        };
    }, [isOpen]);

    return { rootRef };
};
